<!-- Show loading while processesAny is null -->
<div *ngIf="processesAny === null" class="initial-loading">
  <bz-loading [size]="'l'" class="bmc-ai-jobs__loading"></bz-loading>
</div>

<!-- Show content when processesAny is true -->
<ng-container *ngIf="processesAny === true">
  <div class="main-layout">
    <div class="left-container" [ngClass]="{'collapsed': isCollapsed}">
        <biz-processes-tree-view 
            [value]="selected" 
            [applications]="applications"
            (selectedNode)="onSelect($event)"
            (collapseChange)="handleCollapseChange($event)">
        </biz-processes-tree-view>
    </div>
    <div class="right-container" *ngIf="selected" [ngClass]="{'expanded': isCollapsed}">
        <nav class="path-container">
            <ul>    
                <li *ngIf="shouldShowEllipsis()" class="path-divider">
                ...
                <span class="path-divider"> / </span>
                </li>
                <li *ngFor="let node of getVisiblePath(); let last = last">
                    <bzg-icon [nameIcon]="getNodeTypeIcon(node)" [size]="16" [ngClass]="(last ? 'node-icon-last' : 'node-icon')"></bzg-icon>
                    <button type="button" [ngClass] ="(last ? 'path-breadcrumb-link-last' : 'path-breadcrumb-link')">
                        {{ getNodeDisplayName(node) }}
                    </button>
                    <span *ngIf="!last" class="path-divider"> / </span>
                </li>
            </ul>
        </nav>
       
        <p class="bmc-ai-for-processes__title">{{getLastPath()}}</p>
        <p class="bmc-ai-for-processes__description">
            {{ 'AIFORPROCESSES.DESCRIPTION' | translate }}
        </p>       
        <biz-knowledge 
            class="base-knowledge" 
            [knowledgeCategories]="knowledgeCategories"
            [knowledgeData]="knowledgeData"
            (catalogSelectionChanged)="onCatalogSelectionChanged($event)"
            (removeAIBpmKnowledgeBaseEnvironmentItem)="onRemoveAIBpmKnowledgeBaseEnvironmentItem($event)">
        </biz-knowledge>
        <app-ai-parameters-section 
            class="parameters"
            [workerConfigurationData]="workerConfigurationData"
            [hasOverride]="hasOverride"
            (configurationChange)="onAIWorkerConfigurationChange($event)"
            (resetAiWorkerConfiguration)="resetAiWorkerConfiguration($event)">
        </app-ai-parameters-section>
    </div>

    <div *ngIf="!selected" class="no-selection">
        <bz-loading [size]="'l'" class="bmc-ai-jobs__loading"></bz-loading>
    </div>
  </div>
</ng-container>

<!-- Show no records message when processesAny is false -->
<div *ngIf="processesAny === false" class="no-records">
  <img src="assets/img/no_found.png" alt="No records found">
  <span>{{ 'AIFORPROCESSES.NO_RECORD' | translate }}</span>
</div>
